import { CUSTOMERS_FEATURES_ENABLED } from '@src/components/sco/Customers/constants';
import { HomePathCardProps } from '@src/components/sco/Home/HomePaths/HomePathCard';
import { AdvisorsPathIllustration, CustomersPathIllustration, FundingPathIllustration, PitchDeckPathIllustration } from '@src/components/sco/Home/HomePaths/illustrations';
import React from 'react';
export type HomePathItem = Omit<HomePathCardProps, 'illustration'> & {
  id: string;
  illustration: React.ReactNode;
};
export const DEFAULT_HOME_PATHS: HomePathItem[] = [{
  id: 'pitch-deck',
  href: '/pitch-decks',
  title: 'Pitch Deck',
  description: 'Real-world deck audit with step-by-step immediate fixes',
  ctaLabel: 'Audit my Deck',
  proofValue: '1 Million',
  proofLabel: 'Startups Helped',
  illustration: <PitchDeckPathIllustration />
}, {
  id: 'funding',
  href: '/funding',
  title: 'Funding',
  description: 'Raise Capital from Investors.',
  ctaLabel: 'Find Investors',
  proofValue: '$1 Billion',
  proofLabel: 'Raised',
  illustration: <FundingPathIllustration />
}, {
  id: 'advisors',
  href: '/advisors',
  title: 'Advisors',
  description: 'Recruit a World Class Advisory Board.',
  ctaLabel: 'Meet Advisors',
  proofValue: '20,000',
  proofLabel: 'Advisors',
  illustration: <AdvisorsPathIllustration />
}, ...(CUSTOMERS_FEATURES_ENABLED ? [{
  id: 'customers',
  href: '/get-customers',
  title: 'Customers',
  description: 'Find your Early Customers.',
  ctaLabel: 'Find my Customers',
  proofValue: '23M',
  proofLabel: 'Customers Acquired',
  illustration: <CustomersPathIllustration />
} satisfies HomePathItem] : [])];